"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElementWidth = exports.NODE_TYPES = void 0;
var NODE_TYPES;
(function (NODE_TYPES) {
    NODE_TYPES["Window"] = "window";
    NODE_TYPES["Document"] = "#document";
    NODE_TYPES["HTMLElement"] = "htmlElement";
})(NODE_TYPES || (exports.NODE_TYPES = NODE_TYPES = {}));
const getNodeType = (element = window) => {
    if (!('nodeName' in element)) {
        return NODE_TYPES.Window;
    }
    return element.nodeName === NODE_TYPES.Document ? NODE_TYPES.Document : NODE_TYPES.HTMLElement;
};
const getElementWidth = (element = window) => {
    const nodeType = getNodeType(element);
    switch (nodeType) {
        case NODE_TYPES.Window:
            return element.innerWidth;
        case NODE_TYPES.Document:
            return element.documentElement.clientWidth;
        case NODE_TYPES.HTMLElement:
            return element.clientWidth;
        default:
            return element.innerWidth;
    }
};
exports.getElementWidth = getElementWidth;
//# sourceMappingURL=viewport.js.map